import TitleColumn, { cellType, titleColumnConfiguration } from './TitleColumn.component';

export { cellType, TitleColumn };
export default titleColumnConfiguration;
